import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "UPDATE_SCHEDULED_ORDER_FOB_" }
);

export interface UpdateScheduledOrderFOBState extends IState {}

const INITIAL_STATE: UpdateScheduledOrderFOBState = {
  loading: false,
  error: null,
};

const request = (state: UpdateScheduledOrderFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: UpdateScheduledOrderFOBState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: UpdateScheduledOrderFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const updateScheduledOrderFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const UpdateScheduledOrderFOBTypes = Types;
export const UpdateScheduledOrderFOBActions = Creators;
